<script>
    import Icon from 'views/components/icon/Icon.svelte';
    import NumberInput from './parts/NumberInput.svelte';
    import { formatNumber } from './parts/NumberUtil'

    export let model;
    export let response;
    export let syncResponse;

    const taskInfoJson = model.get('task_info_json');

    let isCorrect = false;
    let answerIsOpen = false;
    let givenAnswer = response?.get('json_answer')?.answer || '';
    let inputIsLocked = false;
    let isShowingAuthorAnswer = false;

    export function showAnswer() {
        isCorrect = isAnswerCorrect(givenAnswer)

        inputIsLocked = true;
        answerIsOpen = true;
    }

    export function showAuthorAnswer() {
        isShowingAuthorAnswer = true;
    }

    export function hideAnswer() {
        inputIsLocked = false;
        answerIsOpen = false;
    }

    export function lockAnswer() {
        inputIsLocked = true;
    }

    export function unlockAnswer() {
        inputIsLocked = false;
    }

    export function getCorrectAnswer() {

        const answer = taskInfoJson.answer;

        if (taskInfoJson.marginType === 'none') {
            return window.i18n.sprintf(
                window.i18n.gettext('The correct answer is %s'),
                formatNumber(answer),
            );
        }

        const margin = taskInfoJson.margin;

        let lowerBound;
        let upperBound;

        if (taskInfoJson.marginType === 'percentage') {
            lowerBound = answer - (answer * (margin / 100));
            upperBound = answer + (answer * (margin / 100));
        }

        if (taskInfoJson.marginType === 'absolute') {
            lowerBound = answer - margin;
            upperBound = answer + margin;
        }

        return window.i18n.sprintf(
            window.i18n.gettext('The correct answer is between %s and %s'),
            formatNumber(lowerBound),
            formatNumber(upperBound)
        );
    }

    export function getStudentAnswer(responseModel) {
        if (responseModel.has('json_answer')) {
            let classNameCorrect = ''
            if (model.get('grading_mode') === 'auto') {
                classNameCorrect += isAnswerCorrect(responseModel.get('json_answer').answer) ? 'is-correct' : 'is-incorrect'
            }

            return `<span class="is-boxed ${classNameCorrect}">${formatNumber(responseModel.get('json_answer').answer)}</span>`;
        }
    }

    function isAnswerCorrect(input) {
        input = Number(input);
        const answer = taskInfoJson.answer;
        const margin = taskInfoJson.margin;

        switch (taskInfoJson.marginType) {
            case 'none': {
                return input === answer;
            }

            case 'percentage': {
                const lowerBound = answer - (answer * (margin / 100));
                const upperBound = answer + (answer * (margin / 100));

                return (input >= lowerBound && input <= upperBound);
            }

            case 'absolute': {
                const lowerBound = answer - margin;
                const upperBound = answer + margin;

                return (input >= lowerBound && input <= upperBound);
            }
        }
    }

    const saveResponse = _.debounce(() => {
        syncResponse({
            answer: givenAnswer
        });
    }, 200);
</script>

<article>
    {#if isShowingAuthorAnswer}
        <div class="author-answer">
            {getCorrectAnswer()}
        </div>
    {:else}
        <div
            class="number-input"
            class:correct={answerIsOpen && isCorrect}
            class:incorrect={answerIsOpen && !isCorrect}
        >
            {#if answerIsOpen && !isCorrect}
                <div class="correct-tooltip">
                    <Icon name="checkmark"></Icon>
                    <span>{formatNumber(taskInfoJson.answer)}</span>
                </div>
            {/if}
            <NumberInput
                bind:number={givenAnswer}
                bind:disabled={inputIsLocked}
                callback={() => { saveResponse() }}
            ></NumberInput>
        </div>
    {/if}
</article>

<style lang="scss">
    .author-answer {
        font-size: 16px;
    }

    .number-input {
        position: relative;

        &.correct :global(input) {
            color: $answer-green !important;
            border-color: $answer-green !important;
            background-color: $answer-green-10 !important;
        }

        &.incorrect :global(input) {
            color: $answer-red !important;
            border-color: $answer-red !important;
            background-color: $answer-red-10 !important;
        }
    }

    .correct-tooltip {
        @include normal-text;

        z-index: 100;
        background-color: $blue-black;
        color: $white;
        position: absolute;
        bottom: 100%;
        display: inline-flex;
        align-items: center;
        border-radius: 12px;
        padding: 4px 8px;
        line-height: normal;
        margin-bottom: -8px;
        margin-left: 8px;

        :global(svg) {
            width: 16px;
            height: 16px;
            fill: $status-green;
            margin-right: 4px;
        }

        &:after {
            @include arrow('down', 4px, $blue-black);

            left: 12px;
            top: 100%;
        }
    }
</style>
